/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentData } from './PaymentData';
import {
    PaymentDataFromJSON,
    PaymentDataFromJSONTyped,
    PaymentDataToJSON,
    PaymentDataToJSONTyped,
} from './PaymentData';

/**
 * 
 * @export
 * @interface DailyPaymentData
 */
export interface DailyPaymentData {
    /**
     * 
     * @type {Array<PaymentData>}
     * @memberof DailyPaymentData
     */
    payments?: Array<PaymentData>;
}

/**
 * Check if a given object implements the DailyPaymentData interface.
 */
export function instanceOfDailyPaymentData(value: object): value is DailyPaymentData {
    return true;
}

export function DailyPaymentDataFromJSON(json: any): DailyPaymentData {
    return DailyPaymentDataFromJSONTyped(json, false);
}

export function DailyPaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyPaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(PaymentDataFromJSON)),
    };
}

export function DailyPaymentDataToJSON(json: any): DailyPaymentData {
    return DailyPaymentDataToJSONTyped(json, false);
}

export function DailyPaymentDataToJSONTyped(value?: DailyPaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payments': value['payments'] == null ? undefined : ((value['payments'] as Array<any>).map(PaymentDataToJSON)),
    };
}

